// action constants
import Vue from 'vue'
import { StoreMutations } from './mutations';
import SwiftSpaceRepository from '../../../../api/SwiftSpaceRepository';

export const StoreActions = {
    getReported:'getReported',
    reviewedReported: 'reviewedReported',
    clearState:'clearState'
};

export const actions = {
    [StoreActions.getReported](context) {
        SwiftSpaceRepository.pendingEvents()
        .then((data) => {
            context.commit(StoreMutations.SET_RESULTS,data.events)
        })
        .catch((err) => {
            Vue.prototype.$notify({'type':'danger','content':err})
        });
    },
    [StoreActions.reviewedReported](context, data) {
        SwiftSpaceRepository.reviewEvent(data.id, data)
        .then(() => {
            context.dispatch(StoreActions.getReported);
        })
        .catch((err) => {
            Vue.prototype.$notify({'type':'danger','content':err})
        });
    },
    clearState(context) {
        context.commit(StoreMutations.SET_RESULTS,[]);
    }
};
